import { ThemeEvents } from '@theme/events';

/**
 * Swaps the tax note between the default text and a "free shipping" message
 * depending on whether the currently selected variant's price meets the
 * configured threshold. Updates live on variant change.
 */
class ShippingTaxNoteComponent extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog');
    if (!target) return;

    target.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * @param {Event & { detail?: { resource?: { price?: number } | null, data?: { productId?: string } } }} event
   */
  #onVariantUpdate = (event) => {
    const productId = event.detail?.data?.productId;
    if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

    const variant = event.detail?.resource;
    if (!variant || typeof variant.price !== 'number') return;

    const threshold = Number(this.dataset.thresholdCents ?? 0);
    if (threshold <= 0) return;

    this.dataset.qualifies = variant.price >= threshold ? 'true' : 'false';
  };
}

if (!customElements.get('shipping-tax-note')) {
  customElements.define('shipping-tax-note', ShippingTaxNoteComponent);
}
